import React from 'react';
import styles from './Footer.module.css';
import icApk from "../assets/icon/ic_apk_store.svg";
import icPlayStore from "../assets/icon/ic_play_store.svg";
import logo from "../assets/icon/footer_logo.svg";
import logoText from "../assets/icon/footer_logo_text.svg";
import socialX from "../assets/icon/sat_social_x.svg";
import socialT from "../assets/icon/sat_social_telegram.svg";
import socialD from "../assets/icon/sat_social_discord.svg";
import socialM from "../assets/icon/sat_social_medium.svg";
import socialL from "../assets/icon/sat_social_linkedin.svg";
import {useTranslation} from "react-i18next";


interface MenuColumn {
    title: string;
    items: string[];
    link?: string;
}

const Footer: React.FC = () => {

    const menuColumns: MenuColumn[] = [
        {title: 'Discover', items: ['Get Free Airdrops'], link: 'https://satoshiapp.xyz/en/airdrop'},
        {title: 'List Your Airdrops', items: ['Why Satoshi App', 'Showcases'], link: 'https://satoshiapp.xyz/en/collaboration'},
        {title: 'About Us', items: ['Company Overview'], link: "https://satoshiapp.xyz/en/overview"},
        {title: 'Media', items: ['Blog'], link: 'https://satoshiapp.xyz/en/media'},
        {title: 'Support', items: ['FAQ'], link: 'https://satoshiapp.xyz/en/support'},
    ];

    const socialIcons = [
        {src: socialX, alt: 'X', link: "https://x.com/SatoshiAppXYZ"},
        {src: socialT, alt: 'Telegram', link: "https://t.me/SatoshiAppXYZ"},
        {src: socialD, alt: 'Discord', link: "https://discord.com/invite/Nsyk6Q6hrM"},
        {src: socialM, alt: 'Medium', link: "https://satoshiappxyz.medium.com/"},
        {src: socialL, alt: 'LinkedIn', link: "https://www.linkedin.com/company/satoshiapp/about/"},
    ];

    return (
        <footer className={styles.footerContent}>
            <div className={styles.footerRow}>
                <section className={styles.downloadSection}>
                    <div className={styles.logoContainer} onClick={() => {
                        window.open('https://satoshiapp.xyz', '_blank');
                    }}>
                        <div className={styles.logoWrapper}>
                            <img loading="lazy"
                                 src={logo}
                                 className={styles.logoIcon} alt="Satoshi App Icon"/>
                            <img loading="lazy"
                                 src={logoText}
                                 className={styles.logoText} alt="Satoshi App"/>
                        </div>
                    </div>
                    <div className={styles.downloadContainer}>
                        <div className={styles.downloadText}>Download Satoshi App</div>
                        <div className={styles.storeButtons}>
                            <img onClick={() => {
                                window.open('https://play.google.com/store/apps/details?id=com.sat21.global.pro', '_blank');
                            }}
                                 src={icPlayStore}
                                 className={styles.playStoreImage} alt="Get it on Google Play"/>
                            <div className={styles.appStoreButton}>
                                <img onClick={() => {
                                    window.open('https://satoshiapp.xyz/en/download-app', '_blank');
                                }}
                                     src={icApk}
                                     className={styles.appStoreImage} alt="Download on the App Store"/>
                            </div>

                        </div>
                    </div>
                </section>
                <nav className={styles.footerMenu}>
                    {menuColumns.map((column, index) => (
                        <div key={index} className={styles.menuColumn}>
                            <span className={styles.menuTitle}>{column.title}</span>
                            {column.items.map((item, itemIndex) => (
                                <a key={itemIndex} href={column.link} className={styles.menuItem} target="_blank">
                                    {item}
                                </a>
                            ))}
                        </div>
                    ))}
                </nav>
            </div>
            <div className={styles.divider}>
                <div className={styles.dividerLine}/>
            </div>
            <div className={styles.footerBottom}>
                <section className={styles.communitySection}>
                    <h3 className={styles.communityText}>Join the community</h3>
                    <div className={styles.socialIcons}>
                        {socialIcons.map((icon, index) => (
                            <a key={index} href={icon.link} aria-label={`Visit our ${icon.alt} page`} target="_blank">
                                <img loading="lazy" src={icon.src} className={styles.socialIcon} alt={icon.alt}/>
                            </a>
                        ))}
                    </div>
                </section>
                <section className={styles.copyrightSection}>
                    <p className={styles.copyrightText}>© 2024 Satoshi App</p>
                    <div className={styles.legalLinks}>
                        <a href="https://satoshiapp.xyz/en/privacy-policy" target="_blank">Privacy policy</a>
                        <a href="https://satoshiapp.xyz/en/terms-of-use" target="_blank">Terms of use</a>
                    </div>
                </section>
            </div>
        </footer>
    );
};

export default Footer;